<template>
  <va-edit-layout>
    <robot-department-form
      :id="id"
      :title="title"
      :item="item"
    ></robot-department-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"]
};
</script>
